// extracted by mini-css-extract-plugin
module.exports = {"root":"LineChart_root__jFTf_","chart":"LineChart_chart__rYitu","legend":"LineChart_legend__nwNdk"};